import { Component, EventEmitter, h, Listen, Prop, Event, State } from '@stencil/core';
import { FacetChangeEvent, facetChangeHandler, getData, Option, FacetUpdateEvent, logDebug } from '@hpfc/fc-frontend-core';

/**
 * Normal HP Form style select, wrapped in fccdFacet event handlers.
 */
@Component({
  tag: 'fccd-select',
  styleUrl: 'select.scss',
})
export class Select {
  @State() data: Array<Option>;

  /**
   * The id for the element in this component.
   */
  @Prop() componentName!: string;
  /**
   * The Options to display
   */
  @Prop() options: any;
  /**
   * The header text.
   */
  @Prop() panelLabel: string;
  /**
   * In search most of the time we do not have required fields.  As our form elements are reactive.
   */
  @Prop() required?: boolean = false;
  /**
   * 'true' we should hide the optional label, 'false' otherwise.
   */
  @Prop() hideInputOptionalLabel: boolean = true;
  /**
   * Dispatches this event when a selection is made.
   */
  @Event() fccdFacetChangeEvent: EventEmitter<FacetChangeEvent>;

  componentWillLoad() {
    if (!this.data) {
      this.data = getData(this.options);
    }
  }

  @Listen('hp5ValidationChange')
  selectHandler(event: CustomEvent) {
    facetChangeHandler(this.fccdFacetChangeEvent, event, this.componentName, true);
  }

  @Listen('fccdComponentEvent', { target: 'document' })
  updateHandler(event: CustomEvent<FacetUpdateEvent>) {
    if (event?.detail?.facetOptionMap?.has(this.componentName)) {
      this.data = event.detail.facetOptionMap.get(this.componentName);
      logDebug('caught fccdComponentEvent for element: ' + this.componentName);
    }
  }

  componentDidLoad() {
    logDebug('componentDidLoad()', this.componentName);
  }

  // Notes on the hp5-select it does not allow empty label text so we are feeding it an empty string.
  render() {
    return (
      <div>
        <hp5-select
          element-id={this.componentName}
          height-selection="md"
          hide-input-optional-label={this.hideInputOptionalLabel}
          label={this.panelLabel}
          label-alignment="left"
          label-size="xs"
          label-type="head"
          name={this.componentName}
          options={this.data}
          required={this.required}
        />
      </div>
    );
  }
}
